import styled from 'styled-components'

export const Container = styled.div`
    position: absolute;
    top: 0;
    width: 100vw;
    height: 5vh;
    background: ${props => (props.isDark ? '#089864' : '#10D08B')};
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
`

export const Image = styled.img`
    margin-right: 5px;
`

export const Text = styled.div`
    font-family: Avenir;
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 100%;
    text-align: center;
    color: #ffffff;
`
